<template>
  <div>
    <Head title="新增加購商品" />
    <ScrollTop />

    <Breadcrumb :home="breadcrumb_home" :model="breadcrumb_paths" />

    <div class="w-full flex flex-row items-center justify-end gap-4">
      <div class="flex flex-row items-center gap-2">
        <label for="available">上架</label>
        <InputSwitch
          id="available"
          v-model="add_on.available"
          :disabled="
            !this.add_on.merchandise ||
            !this.add_on.name ||
            !this.add_on.settings.discount.original_price
          "
        />
      </div>
      <Button
        label="儲存"
        @click="saveProduct"
        :disabled="
          !this.add_on.merchandise ||
          !this.add_on.name ||
          !this.add_on.settings.discount.original_price ||
          !this.add_on.settings.discount.discount_price
        "
      />
    </div>

    <TabView>
      <TabPanel header="商品資訊">
        <div class="border border-fh-gray-light px-3">
          <div class="py-3">
            <div class="mt-1">基礎商品資料</div>
            <div class="border border-fh-gray-light px-3">
              <div class="py-3">
                <div
                  class="mt-1 flex flex-row gap-4 justify-between items-center"
                >
                  <div
                    v-if="add_on.merchandise"
                    class="flex flex-row gap-4 items-center"
                  >
                    <div>
                      <template
                        v-if="
                          Array.isArray(add_on.merchandise.images) &&
                          add_on.merchandise.images.length > 0
                        "
                      >
                        <div
                          class="
                            w-[50px]
                            h-[50px]
                            bg-fh-gray-light
                            flex
                            items-center
                            justify-center
                            bg-cover bg-center
                          "
                          :style="{
                            'background-image':
                              'url(\'/storage/product-images/' +
                              add_on.merchandise.images[0] +
                              '/50.jpg\')',
                          }"
                        ></div>
                      </template>
                      <template v-else>
                        <div
                          class="
                            w-[50px]
                            h-[50px]
                            bg-fh-gray-light
                            flex
                            items-center
                            justify-center
                          "
                        >
                          無
                        </div>
                      </template>
                    </div>
                    <div>{{ add_on.merchandise.name }}</div>
                    <div>
                      {{ add_on.merchandise.price | commaFormat | priceFormat }}
                    </div>
                    <div>CV{{ add_on.merchandise.cv | commaFormat }}</div>
                    <div>
                      <Tag
                        class="mr-2"
                        :severity="
                          add_on.merchandise.available == 1
                            ? 'success'
                            : 'danger'
                        "
                      >
                        {{
                          add_on.merchandise.available == 1
                            ? "上架中"
                            : "未上架"
                        }}
                      </Tag>
                    </div>
                  </div>
                  <div v-else>未指定商品</div>
                  <div>
                    <Button label="指定商品" @click="changeMerchandise" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="py-3">
            <div class="mt-1">
              <label for="name">加購商品名稱</label>
            </div>
            <div class="mt-1">
              <InputText id="name" v-model="add_on.name" class="w-full" />
            </div>
          </div>
        </div>
      </TabPanel>
      <TabPanel header="價格與數量">
        <div class="border border-fh-gray-light px-3">
          <div class="pt-3">
            <div class="mt-1">
              <label for="original_price">商品價格</label>
            </div>
            <div class="mt-1">
              <InputText
                id="original_price"
                v-model="add_on.settings.discount.original_price"
              />
            </div>
          </div>

          <div class="pt-3">
            <div class="mt-1">
              <label for="discount_price">優惠價格</label>
            </div>
            <div class="mt-1">
              <InputText
                id="discount_price"
                v-model="add_on.settings.discount.discount_price"
              />
            </div>
          </div>

          <div class="pt-3">
            <div class="mt-1">
              <label for="original_cv">商品CV</label>
            </div>
          </div>
          <div class="mt-1">
            <InputText
              id="original_cv"
              v-model="add_on.settings.discount.original_cv"
            />
          </div>

          <div class="pt-3">
            <div class="mt-1">
              <label for="discount_cv">優惠CV</label>
            </div>
          </div>
          <div class="mt-1">
            <InputText
              id="discount_cv"
              v-model="add_on.settings.discount.discount_cv"
            />
          </div>

          <div class="py-3">
            <div class="mt-1">
              <label>運送方式</label>
            </div>
            <div class="mt-1">
              <SelectButton
                v-model="selected_delivery"
                :options="deliveries"
                optionLabel="name"
                optionValue="code"
                dataKey="code"
                :disabled="true"
              />
            </div>
          </div>
        </div>
      </TabPanel>
      <TabPanel header="商品設定">
        <div class="border border-fh-gray-light px-3">
          <div class="mt-10 w-full flex justify-between">
            <div class="mt-1">
              <div>加長備貨時間</div>
              <small>功能啟用後，將於商品頁面告知需加長備貨時間。</small>
            </div>
            <div class="mt-1">
              <InputSwitch
                v-model="add_on.attributes.is_long_lead"
                :disabled="true"
              />
            </div>
          </div>

          <div class="my-10 w-full flex justify-between">
            <div class="mt-1">
              <div>限定商品銷售期間</div>
              <small>功能啟用後，上架商品僅能在設定的銷售期間內被購買。</small>
              <div class="mt-4 flex flex-row gap-4">
                <div>
                  開始日期
                  <Calendar
                    v-model="duration.start"
                    :maxDate="duration.end"
                    selectionMode="single"
                  />
                </div>
                <div>
                  結束日期
                  <Calendar
                    v-model="duration.end"
                    :minDate="duration.start"
                    selectionMode="single"
                  />
                </div>
              </div>
            </div>
            <div class="mt-1">
              <InputSwitch v-model="add_on.settings.time_limit" />
            </div>
          </div>
        </div>
      </TabPanel>
    </TabView>
    <Dialog :visible.sync="show_dialog" :modal="true">
      <div class="w-full h-full">
        <DataTable
          :value="
            merchandises.filter((merchandise) => {
              return merchandise.name.includes(this.merchandise_search);
            })
          "
          :selection.sync="selectedMerchandise"
        >
          <template #header>
            <div class="flex justify-between items-center">
              <div></div>
              <div class="flex flex-row items-center gap-2">
                <span class="p-input-icon-left">
                  <i class="pi pi-search" />
                  <InputText
                    class="w-52"
                    v-model="merchandise_search"
                    placeholder="搜尋商品"
                  />
                </span>
              </div>
            </div>
          </template>
          <Column headerClass="w-11" selectionMode="single"></Column>
          <Column headerClass="w-14" field="images" header="圖片">
            <template #body="slotProps">
              <template
                v-if="
                  Array.isArray(slotProps.data.images) &&
                  slotProps.data.images.length > 0
                "
              >
                <div
                  class="
                    w-[50px]
                    h-[50px]
                    bg-fh-gray-light
                    flex
                    items-center
                    justify-center
                    bg-cover bg-center
                  "
                  :style="{
                    'background-image':
                      'url(\'/storage/product-images/' +
                      slotProps.data.images[0] +
                      '/50.jpg\')',
                  }"
                ></div>
              </template>
              <template v-else>
                <div
                  class="
                    w-[50px]
                    h-[50px]
                    bg-fh-gray-light
                    flex
                    items-center
                    justify-center
                  "
                >
                  無
                </div>
              </template>
            </template>
          </Column>
          <Column headerClass="w-52" field="name" header="商品名稱" sortable>
          </Column>
          <Column headerClass="w-24" field="price" header="價格" sortable>
            <template #body="slotProps">
              {{ slotProps.data.price | commaFormat | priceFormat }}
            </template>
          </Column>
          <Column headerClass="w-24" field="cv" header="CV" sortable>
            <template #body="slotProps">
              {{ slotProps.data.cv | commaFormat }}
            </template>
          </Column>
          <Column
            headerClass="w-24"
            field="available"
            header="商品狀態"
            sortable
          >
            <template #body="slotProps">
              <Tag
                class="mr-2"
                :severity="slotProps.data.available == 1 ? 'success' : 'danger'"
              >
                {{ slotProps.data.available == 1 ? "上架中" : "未上架" }}
              </Tag>
            </template>
          </Column>
        </DataTable>
      </div>
      <template #footer>
        <div class="mt-2">
          <Button
            label="選擇商品"
            :disabled="selectedMerchandise == null"
            @click="selectMerchandise"
          />
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import Layout from "../Layout";
import ScrollTop from "primevue/scrolltop";
import Breadcrumb from "@/Shared/Components/Breadcrumb";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import Checkbox from "primevue/checkbox";
import SelectButton from "primevue/selectbutton";
import InputSwitch from "primevue/inputswitch";
import Calendar from "primevue/calendar";
import Tag from "primevue/tag";
import Dialog from "primevue/dialog";
import DataTable from "primevue/datatable";
import Column from "primevue/column";

export default {
  components: {
    ScrollTop,
    Breadcrumb,
    TabView,
    TabPanel,
    Button,
    InputText,
    Checkbox,
    SelectButton,
    InputSwitch,
    Calendar,
    Tag,
    Dialog,
    DataTable,
    Column,
  },
  layout: Layout,
  filters: {
    priceFormat: function (value) {
      return "$" + value;
    },
    commaFormat: function (value) {
      return value
        .toString()
        .replace(
          /^(-?\d+?)((?:\d{3})+)(?=\.\d+$|$)/,
          function (all, pre, groupOf3Digital) {
            return pre + groupOf3Digital.replace(/\d{3}/g, ",$&");
          }
        );
    },
  },
  data() {
    return {
      from: null,
      breadcrumb_home: {
        label: "商品分類管理",
        disabled: true,
      },
      breadcrumb_paths: [
        {
          label: "加購商品",
          to: this.$page.props.from
            ? decodeURIComponent(atob(this.$page.props.from))
            : route("admin.add_on"),
        },
        {
          label: "新增",
          disabled: true,
        },
      ],
      deliveries: [
        { name: "常溫", code: "normal" },
        { name: " 冷藏", code: "refrigerated" },
        { name: "冷凍", code: "frozen" },
      ],
      selected_delivery: null,
      add_on: this.$page.props.add_on,
      duration: {
        start:
          this.$page.props.add_on.settings?.duration?.start == null
            ? null
            : new Date(this.$page.props.add_on.settings?.duration?.start),
        end:
          this.$page.props.add_on.settings?.duration?.end == null
            ? null
            : new Date(this.$page.props.add_on.settings?.duration?.end),
        // start: new Date(this.$page.props.settings.duration.start),
        // end: new Date(this.$page.props.settings.duration.end),
      },
      categories: this.$page.props.categories,
      show_dialog: false,
      merchandises: [],
      selectedMerchandise: null,
      merchandise_search: "",
    };
  },
  computed: {
    //
  },
  methods: {
    selectMerchandise() {
      this.add_on.merchandise = this.selectedMerchandise;
      this.add_on.name = this.selectedMerchandise.name;
      this.add_on.cv = this.selectedMerchandise.cv;
      this.add_on.price = this.selectedMerchandise.price;
      this.add_on.attributes = this.selectedMerchandise.attributes;
      this.selected_delivery = _.findKey(this.add_on.attributes.delivery);
      this.add_on.settings.on_sale = null;
      this.add_on.settings.discount = {
        original_price: parseInt(
          this.selectedMerchandise.settings.discount.original_price
        ),
        discount_price: parseInt(
          this.selectedMerchandise.settings.discount.discount_price
        ),
        original_cv: parseInt(
          this.selectedMerchandise.settings.discount.original_cv
        ),
        discount_cv: parseInt(
          this.selectedMerchandise.settings.discount.discount_cv
        ),
      };
      this.show_dialog = false;
    },
    changeMerchandise() {
      this.selectedMerchandise = null;
      axios.get(route("admin.fetch.merchandises")).then((response) => {
        this.merchandises = response.data;
        this.show_dialog = true;
      });
    },
    saveProduct() {
      this.$inertia.post(route("admin.add_on.new"), {
        payload: this.result(),
        to: this.$page.props.from
          ? decodeURIComponent(atob(this.$page.props.from))
          : route("admin.add_on"),
      });
    },
    result() {
      let settings = {
        duration: {
          start: this.duration.start,
          end: this.duration.end,
        },
        time_limit: this.add_on.settings.time_limit,
        on_sale: null,
        discount: {
          original_price: parseInt(
            this.add_on.settings.discount.original_price
          ),
          discount_price: parseInt(
            this.add_on.settings.discount.discount_price
          ),
          original_cv: parseInt(this.add_on.settings.discount.original_cv),
          discount_cv: parseInt(this.add_on.settings.discount.discount_cv),
        },
      };

      let payload = {
        merchandise_id: this.add_on.merchandise.id,
        name: this.add_on.name,
        price: this.add_on.price,
        cv: this.add_on.cv,
        available: this.add_on.available,
        settings: settings,
      };

      return payload;
    },
  },
  mounted() {
    //
  },
};
</script>

<style lang="postcss">
.p-breadcrumb {
  @apply border-0;
}
</style>